import { FaTwitter, FaBluesky, FaGithub, FaLinkedin} from 'react-icons/fa6';

const socialInfo = [
  { 
    link: 'https://x.com/acopperlily', 
    icon: FaTwitter,
    label: 'Twitter'
  },
  {
    link: 'https://bsky.app/profile/acopperlily.bsky.social',
    icon: FaBluesky,
    label: 'Bluesky'
  },
  { 
    link: 'https://github.com/acopperlily', 
    icon: FaGithub,
    label: 'GitHub'
  },
  { 
    link: 'https://www.linkedin.com/in/april-copley', 
    icon: FaLinkedin,
    label: 'LinkedIn'
  }
];

export default socialInfo;
